import React, { useMemo } from 'react';
import {
  MdmPolicyContainerProps,
  FormErrors,
  FormState,
  FormMeta
} from '../types/interface';
import { PROXY_FORM_FIELDS } from './Metas/ProxyMeta';
import GenericForm from './GenericForm';
import PolicyTitle from './PolicyTitle';
import { DisplayText } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';

interface MDMProxyProps extends MdmPolicyContainerProps {
  formValues: FormState;
  formErrors: FormErrors;
  onFormValuesChange: (newValues: FormState) => void;
  policyObj?: any;
  enabled?: boolean;
  onEnabledChange?: (enabled: boolean) => void;
  disabled?: boolean;
  isReadOnly?: boolean;
}

function MDMProxy(props: MDMProxyProps) {
  const {
    policyObj: policy,
    formValues,
    formErrors,
    onFormValuesChange,
    intl,
    enabled = true,
    onEnabledChange,
    disabled = false,
    isReadOnly = false
  } = props;

  const formFields = useMemo<FormMeta[]>(() => {
    return PROXY_FORM_FIELDS;
  }, []);

  const handleFormChange = (
    fieldName: string,
    value: string | number | boolean
  ) => {
    let processedValue: string | number | boolean | null = value;
    if (typeof value === 'string' && value.trim() === '') {
      processedValue = null;
    }

    // First update the changed field
    const newValues = { ...formValues, [fieldName]: processedValue };

    // Propagate to parent (parent will handle conditional field clearing)
    onFormValuesChange(newValues);
  };

  return (
    <div className="mdm-proxy-container">
      <div className="flex col g20">
        <div>
          <PolicyTitle
            policyName="mdm.policy.network.proxy.label"
            policy={policy || null}
            enabled={enabled}
            onEnabledChange={onEnabledChange}
            disabled={disabled}
            showToggle={true}
            isReadOnly={isReadOnly}
            isTitle
          />
          <DisplayText element="p" size="medium" variant="subdued">
            {getTranslatedText(intl, 'mdm.policy.network.proxy.desc')}
          </DisplayText>
        </div>
        <div className="mt-20 w500">
          <GenericForm
            intl={intl}
            fields={formFields}
            formValues={formValues}
            formErrors={formErrors}
            onChange={handleFormChange}
            disabled={false}
            showDeviceTypeBadges={false}
          />
        </div>
      </div>
    </div>
  );
}

export default MDMProxy;
